import Base from './Base'
import Home from './Home'
import About from './About'
import Carta from './Carta'
import Servicios from './Servicios'
import TripleImpacto from './TripleImpacto'
import Detail from './Detail'
import Trabaja from './Trabaja'
import Medios from './Medios'
import Contacto from './Contacto'
import Gobierno from './Gobierno'

export {
    Base,
    Home,
    About,
    Carta,
    Servicios,
    TripleImpacto,
    Detail,
    Trabaja,
    Medios,
    Contacto,
    Gobierno
}